import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { slugify } from 'transliteration';
import { connect } from 'react-redux';
import {withTranslation} from "react-i18next";

const slugifyOptions = {
  lowercase: true,
  trim: true,
  replace: [
    ['.', ''],
    ['…', '']
  ]
}

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );

class TitleCard extends PureComponent {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    slogan: PropTypes.string,
    status: PropTypes.string,
  };

  updatePermlinkFromTitle = (title) => {
    const permlink = slugify(title, slugifyOptions)
    this.props.change('permlink', permlink);
  }

  render() {
    const { handleSubmit, title, slogan, status, t } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{title}</h5>
              {slogan && <h5 className="subhead">{slogan}</h5>}
            </div>
            <form className="form form--vertical" onSubmit={handleSubmit}>
              <div className="form__form-group">

                <Field name="draftId" component={()=> null} />

                <span className="form__form-group-label">{t('write.form_title.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="title"
                    component={renderField}
                    type="text"
                    placeholder="Type article title here"
                    onChange={(event) => {
                      if (status !== 'published') {
                        this.updatePermlinkFromTitle(event.target.value)
                      } }}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">{t('write.form_permlink')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="permlink"
                    component="input"
                    type="text"
                    disabled={true}
                  />
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blog: state.blogs.blog
  }
};

TitleCard = connect(mapStateToProps)(TitleCard);

export default reduxForm({
  form: 'article', // a unique identifier for this form
  destroyOnUnmount: false,
})(withTranslation('dashboard')(TitleCard));
